module.exports = __webpack_public_path__ + "img/yuangongrenzheng.7bead293.png";